import React, { useState, useEffect } from 'react';
import validationAuth from '../../../validationAuth';
import {
    Box, Typography, Button, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Paper, TablePagination, Dialog,
    DialogActions, DialogContent, DialogTitle, IconButton, Pagination,
    useMediaQuery, Alert, DialogContentText, Card, CardContent,
    CardActions, Divider, Chip, Stack, Collapse, TextField, FormControl,
    InputLabel, Select, MenuItem
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import axios from 'axios';
import * as common from '../../../commons/common';
import SearchArea from '../../../components/managerPage/searchArea'
import {getImageBaseUrl} from "../../../commons/common";

const QRManagement = () => {
    const theme = useTheme();
    const [alert, setAlert] = useState('');
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const [facilityTypes, setFacilityTypes] = useState([]);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [qrToRegenerate, setQrToRegenerate] = useState(null);

    // 모바일 검색폼 토글 상태 추가
    const [isSearchOpen, setIsSearchOpen] = useState(false);

    const [searchFacilityTypeId, setSearchFacilityTypeId] = useState('');
    const [searchFacilityNm, setSearchFacilityNm] = useState('');
    const [searchParams, setSearchParams] = useState({
        facilityTypeId: '',
        facilityNm: '',
        pageSize: '',
        pageNumber: '',
    });
    const [qrList, setQRList] = useState([]);

    const [qrModalOpen, setQrModalOpen] = useState(false);
    const [selectedQrType, setSelectedQrType] = useState('COMPLAINT');
    const [selectedQrDetailInfo, setSelectedQrDetailInfo] = useState({});

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalElements, setTotalElements] = useState(0);

    const [historyModalOpen, setHistoryModalOpen] = useState(false);
    const [qrHistory, setQrHistory] = useState([]);
    const [isLoadingHistory, setIsLoadingHistory] = useState(false);

    useEffect(() => {
        const getFacilityType = async () => {
            const url = `${common.getApiUrl()}/facility-type`;
            const token = localStorage.getItem('access_token');

            try {
                const response = await axios.get(url, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                });

                if (response.data && Array.isArray(response.data)) {
                    const fetchedItems = response.data.map((type) => ({
                        value: type.facilityTypeId,
                        label: type.facilityTypeNm,
                    }));
                    fetchedItems.unshift({ value: ' ', label: '전체' });
                    setFacilityTypes(fetchedItems);
                }
            } catch (error) {
                console.error('데이터를 가져오는 데 실패했습니다:', error);
            }
        };
        getFacilityType();
    }, []);

    useEffect(() => {
        fetchQRList();
    }, [page, rowsPerPage]);

    const fetchQRList = async () => {
        const token = localStorage.getItem('access_token');
        const url = `${common.getApiUrl()}/admin/facility`;
        try {
            const params = {
                facilityTypeId: searchParams.facilityTypeId,
                facilityNm: searchParams.facilityNm,
                page: page,
                pageSize: rowsPerPage,
            };

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                params
            });

            if (response.data && Array.isArray(response.data.content)) {
                setQRList(response.data.content);
                setTotalElements(response.data.totalElements);
            }
        } catch (error) {
            console.error("Failed to fetch qrList:", error);
        }
    };

    const handleSearchParamsChange = (name, value) => {
        if (name === 'facilityTypeId') {
            setSearchParams(prevState => ({
                ...prevState,
                [name]: value,
            }));
            setSearchFacilityTypeId(value);
        } else if (name === 'facilityNm') {
            setSearchParams(prevState => ({
                ...prevState,
                [name]: value,
            }));
            setSearchFacilityNm(value);
        }
    };

    const handleSearch = async () => {
        setPage(1);
        fetchQRList();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setRowsPerPage(newSize);
        setPage(1);
    };

    const handleOpenQRModal = async (selectedfacilityId, qrType) => {
        try {
            setSelectedQrType(qrType)
            const token = localStorage.getItem('access_token');
            const url = `${common.getApiUrl()}/facility/qr-image`;
            const response = await axios.get(url, {
                params: {
                    facilityId: selectedfacilityId,
                    qrType: qrType
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            if (response.data) {
                const item = qrList.find(item => item.facilityId === selectedfacilityId)
                setSelectedQrDetailInfo(prevState => ({
                    ...prevState,
                    facilityId: item.facilityId,
                    facilityNm: item.facilityNm,
                    complaintQrUrl: item.complaintQrUrl,
                    checkerQrUrl: item.checkerQrUrl,
                    qrImageUrl: response.data.qrImageUrl !== null ? `${common.getImageBaseUrl()}${response.data.qrImageUrl}` : '',
                }));
            } else {
                const item = qrList.find(item => item.facilityId === selectedfacilityId)
                setSelectedQrDetailInfo(prevState => ({
                    ...prevState,
                    facilityId: item.facilityId,
                    facilityNm: item.facilityNm,
                }));
            }
            setQrModalOpen(true);
        } catch (error) {
            console.error("Failed to fetch qr data:", error);
        }
    };

    const handleGenerateQrClick = (facilityId, qrType) => {
        setQrToRegenerate({ facilityId, qrType });
        setConfirmDialogOpen(true);
    };

    const fetchQrHistory = async (facilityId, qrType) => {
        setIsLoadingHistory(true);
        try {
            const token = localStorage.getItem('access_token');
            const url = `${common.getApiUrl()}/admin/facility/qr-history`;
            const response = await axios.get(url, {
                params: {
                    facilityId,
                    qrType: "CHECKER"
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.data) {
                setQrHistory(response.data);
            } else {
                setQrHistory([]);
            }
        } catch (error) {
            console.error("Failed to fetch QR history:", error);
            setQrHistory([]);
            setAlert('QR 발행 이력을 불러오는데 실패했습니다.');
        } finally {
            setIsLoadingHistory(false);
        }
    };

    const handleOpenHistoryModal = (facilityId) => {
        fetchQrHistory(facilityId, selectedQrType);
        setHistoryModalOpen(true);
    };

    const handleCloseHistoryModal = () => {
        setHistoryModalOpen(false);
    };

    const handleConfirmGenerate = async () => {
        if (!qrToRegenerate) return;

        try {
            const response = await axios.post(`${common.getApiUrl()}/facility/qr-image`, {
                facilityId: qrToRegenerate.facilityId,
                qrType: qrToRegenerate.qrType
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                },
            });
            setSelectedQrDetailInfo(prev => ({
                ...prev,
                qrImageUrl: `${common.getImageBaseUrl()}${response.data.qrImageUrl}`,
                checkerQrUrl: ''
            }));
            setAlert('QR 코드가 발행되었습니다.')
            fetchQRList()
        } catch (error) {
            setAlert('QR 코드 발행을 실패했습니다.')
        } finally {
            setConfirmDialogOpen(false);
            setQrToRegenerate(null);
        }
    };

    const handleCancelGenerate = () => {
        setConfirmDialogOpen(false);
        setQrToRegenerate(null);
    };

    const handleCloseQrModal = () => {
        setAlert('')
        setSelectedQrDetailInfo({});
        setQrModalOpen(false);
    };

    // 모바일용 카드 컴포넌트 - 최대한 컴팩트하게 개선
    const MobileCard = ({ item }) => (
        <Box sx={{
            width: '100%',
            maxWidth: '100%',
            mb: 0.5, // 카드 간격 대폭 축소
            overflow: 'hidden',
            boxSizing: 'border-box'
        }}>
            <Card sx={{
                boxShadow: 1,
                border: '1px solid #e0e0e0',
                borderRadius: '6px', // 모서리 둥글기 줄임
                overflow: 'hidden',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
            }}>
                <CardContent sx={{
                    p: 1, // 패딩 대폭 축소
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                    '&:last-child': { pb: 1 }
                }}>
                    {/* 시설명과 유형 */}
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 0.5, // 여백 축소
                        gap: 0.5,
                        width: '100%',
                        maxWidth: '100%'
                    }}>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '0.8rem', // 폰트 크기 축소
                                flex: 1,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                minWidth: 0
                            }}
                        >
                            {item.facilityNm}
                        </Typography>
                        <Chip
                            label={item.facilityTypeNm}
                            size="small"
                            color="primary"
                            variant="outlined"
                            sx={{
                                fontSize: '0.6rem', // 폰트 크기 축소
                                height: '18px', // 높이 축소
                                flexShrink: 0,
                                maxWidth: '70px',
                                '& .MuiChip-label': {
                                    px: 0.3,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }
                            }}
                        />
                    </Box>

                    {/* 부서 정보와 버튼을 가로로 배치 */}
                    <Box sx={{
                        display: 'flex',
                        gap: 1,
                        alignItems: 'flex-end', // 하단 정렬로 변경
                        width: '100%',
                        maxWidth: '100%'
                    }}>
                        {/* 부서 정보 - 3줄로 표시 */}
                        <Box sx={{
                            flex: 1,
                            minWidth: 0, // flex에서 텍스트 오버플로우 처리를 위해 필요
                        }}>
                            {item.topDeptNm && (
                                <Typography
                                    variant="caption"
                                    sx={{
                                        fontSize: '0.65rem',
                                        color: 'text.secondary',
                                        display: 'block',
                                        mb: 0.2,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    본부: {item.topDeptNm}
                                </Typography>
                            )}
                            {item.midDeptNm && (
                                <Typography
                                    variant="caption"
                                    sx={{
                                        fontSize: '0.65rem',
                                        color: 'text.secondary',
                                        display: 'block',
                                        mb: 0.2,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    부서: {item.midDeptNm}
                                </Typography>
                            )}
                            {item.botDeptNm && (
                                <Typography
                                    variant="caption"
                                    sx={{
                                        fontSize: '0.65rem',
                                        color: 'text.secondary',
                                        display: 'block',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    팀: {item.botDeptNm}
                                </Typography>
                            )}
                            {/* 부서 정보가 없는 경우 */}
                            {!item.topDeptNm && !item.midDeptNm && !item.botDeptNm && (
                                <Typography
                                    variant="caption"
                                    sx={{
                                        fontSize: '0.65rem',
                                        color: 'text.secondary',
                                        display: 'block'
                                    }}
                                >
                                    부서 정보 없음
                                </Typography>
                            )}
                        </Box>

                        {/* 버튼 - 세로로 배치하되 하단부터 쌓아올리기 */}
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column-reverse', // 역순으로 배치하여 하단부터 쌓기
                            gap: 0.3,
                            flexShrink: 0,
                            width: '60px', // 버튼 영역 고정 너비
                        }}>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => handleOpenQRModal(item.facilityId, "COMPLAINT")}
                                sx={{
                                    fontSize: '0.6rem', // 폰트 크기 축소
                                    py: 0.2, // 패딩 축소
                                    minHeight: '22px', // 높이 축소
                                    textTransform: 'none',
                                    lineHeight: 1.2,
                                    width: '100%'
                                }}
                            >
                                민원인
                            </Button>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => handleOpenQRModal(item.facilityId, "CHECKER")}
                                sx={{
                                    fontSize: '0.6rem', // 폰트 크기 축소
                                    py: 0.2, // 패딩 축소
                                    minHeight: '22px', // 높이 축소
                                    textTransform: 'none',
                                    lineHeight: 1.2,
                                    width: '100%'
                                }}
                            >
                                점검자
                            </Button>
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );

    // 데스크톱 테이블 컴포넌트
    const DesktopTable = () => (
        <TableContainer>
            <Table stickyHeader sx={{ padding: '0 10px' }}>
                <TableHead sx={{ backgroundColor: '#fff' }}>
                    <TableRow sx={{ height: '57px' }}>
                        <TableCell align="center" sx={{ padding: '8px', fontWeight: 'bold', fontSize: isTablet ? '0.875rem' : '1rem' }}>시설유형</TableCell>
                        <TableCell align="center" sx={{ padding: '8px', fontWeight: 'bold', fontSize: isTablet ? '0.875rem' : '1rem' }}>시설명</TableCell>
                        <TableCell align="center" sx={{ padding: '8px', fontWeight: 'bold', fontSize: isTablet ? '0.875rem' : '1rem' }}>관리본부</TableCell>
                        <TableCell align="center" sx={{ padding: '8px', fontWeight: 'bold', fontSize: isTablet ? '0.875rem' : '1rem' }}>관리부서</TableCell>
                        <TableCell align="center" sx={{ padding: '8px', fontWeight: 'bold', fontSize: isTablet ? '0.875rem' : '1rem' }}>팀</TableCell>
                        <TableCell align="center" sx={{ padding: '8px', fontWeight: 'bold', fontSize: isTablet ? '0.875rem' : '1rem' }}>민원인 QR</TableCell>
                        <TableCell align="center" sx={{ padding: '8px', fontWeight: 'bold', fontSize: isTablet ? '0.875rem' : '1rem' }}>점검자 QR</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody sx={{ backgroundColor: '#fff' }}>
                    {qrList.map((item, index) => (
                        <TableRow key={item.facilityId || index} sx={{ height: '54px' }}>
                            <TableCell align="center" sx={{ width: '15%', padding: '8px', color: 'rgb(112, 112, 112)', fontSize: isTablet ? '0.75rem' : '0.875rem' }}>{item.facilityTypeNm}</TableCell>
                            <TableCell align="center" sx={{ width: '20%', padding: '8px', color: 'rgb(112, 112, 112)', fontSize: isTablet ? '0.75rem' : '0.875rem' }}>{item.facilityNm}</TableCell>
                            <TableCell align="center" sx={{ width: '13%', padding: '8px', color: 'rgb(112, 112, 112)', fontSize: isTablet ? '0.75rem' : '0.875rem' }}>{item.topDeptNm}</TableCell>
                            <TableCell align="center" sx={{ width: '13%', padding: '8px', color: 'rgb(112, 112, 112)', fontSize: isTablet ? '0.75rem' : '0.875rem' }}>{item.midDeptNm}</TableCell>
                            <TableCell align="center" sx={{ width: '13%', padding: '8px', color: 'rgb(112, 112, 112)', fontSize: isTablet ? '0.75rem' : '0.875rem' }}>{item.botDeptNm}</TableCell>
                            <TableCell sx={{ width: '10%', padding: '8px', color: 'rgb(112, 112, 112)' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <IconButton
                                        onClick={() => handleOpenQRModal(item.facilityId, "COMPLAINT")}
                                        color="primary"
                                        size={isTablet ? "small" : "medium"}
                                    >
                                        <SearchIcon fontSize={isTablet ? "small" : "medium"} />
                                    </IconButton>
                                </Box>
                            </TableCell>
                            <TableCell sx={{ width: '10%', padding: '8px', color: 'rgb(112, 112, 112)' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <IconButton
                                        onClick={() => handleOpenQRModal(item.facilityId, "CHECKER")}
                                        color="primary"
                                        size={isTablet ? "small" : "medium"}
                                    >
                                        <SearchIcon fontSize={isTablet ? "small" : "medium"} />
                                    </IconButton>
                                </Box>
                            </TableCell>
                        </TableRow>
                    ))}
                    {Array.from({ length: rowsPerPage - qrList.length }).map((_, index) => (
                        <TableRow key={`empty-row-${index}`} sx={{ height: '54px' }}>
                            <TableCell colSpan={7} sx={{ padding: '8px' }} />
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );

    return (
        <Box sx={{
            width: '100%',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            // 모바일에서 전체 스크롤을 위한 설정
            ...(isMobile ? {
                //p: 2,
                overflow: 'hidden',
                boxSizing: 'border-box',
                maxWidth: '100%'
            } : {
                mx: -3,
                px: 3
            })
        }}>
            {/* 제목과 모바일 검색 버튼 */}
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 2,
                width: '100%',
                flexShrink: 0 // 고정 크기
            }}>
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 'bold',
                        fontSize: isMobile ? '1.2rem' : '1.5rem',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}
                >
                    QR 관리
                </Typography>

                {/* 모바일에서만 검색 토글 버튼 표시 */}
                {isMobile && (
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<FilterListIcon />}
                        endIcon={isSearchOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        onClick={() => setIsSearchOpen(!isSearchOpen)}
                        sx={{
                            fontSize: '0.75rem',
                            py: 0.5,
                            px: 1,
                            minHeight: '32px',
                            textTransform: 'none'
                        }}
                    >
                        검색
                    </Button>
                )}
            </Box>

            {/* 검색 영역 - 모바일에서는 토글, 데스크톱에서는 항상 표시 */}
            {isMobile ? (
                <Collapse in={isSearchOpen} timeout="auto" unmountOnExit>
                    <Box sx={{
                        mb: 2,
                        p: 1.5,
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        backgroundColor: '#fafafa',
                        width: '100%',
                        maxWidth: '100%',
                        boxSizing: 'border-box'
                    }}>
                        <Stack spacing={1.5} sx={{ width: '100%' }}>
                            <FormControl size="small" fullWidth>
                                <InputLabel sx={{ fontSize: '0.875rem' }}>시설유형</InputLabel>
                                <Select
                                    value={searchFacilityTypeId}
                                    label="시설유형"
                                    onChange={(e) => handleSearchParamsChange('facilityTypeId', e.target.value)}
                                    sx={{
                                        fontSize: '0.875rem',
                                        width: '100%',
                                        maxWidth: '100%',
                                        boxSizing: 'border-box'
                                    }}
                                >
                                    {facilityTypes.map((type) => (
                                        <MenuItem key={type.value} value={type.value} sx={{ fontSize: '0.875rem' }}>
                                            {type.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <TextField
                                size="small"
                                fullWidth
                                label="시설명"
                                value={searchFacilityNm}
                                onChange={(e) => handleSearchParamsChange('facilityNm', e.target.value)}
                                sx={{
                                    '& .MuiInputLabel-root': { fontSize: '0.875rem' },
                                    '& .MuiOutlinedInput-root': {
                                        fontSize: '0.875rem',
                                        width: '100%',
                                        maxWidth: '100%',
                                        boxSizing: 'border-box'
                                    }
                                }}
                            />

                            <Button
                                variant="contained"
                                fullWidth
                                startIcon={<SearchIcon />}
                                onClick={() => {
                                    handleSearch();
                                    setIsSearchOpen(false);
                                }}
                                sx={{
                                    fontSize: '0.875rem',
                                    py: 1,
                                    textTransform: 'none',
                                    width: '100%',
                                    maxWidth: '100%',
                                    boxSizing: 'border-box'
                                }}
                            >
                                검색
                            </Button>
                        </Stack>
                    </Box>
                </Collapse>
            ) : (
                <Box sx={{
                    mb: 2,
                    width: '100%',
                    maxWidth: '100%',
                    overflow: 'hidden',
                    flexShrink: 0
                }}>
                    <SearchArea
                        searchValues={{ facilityNm: searchFacilityNm, facilityTypeId: searchFacilityTypeId }}
                        handleSearchChanges={(name, value) => { handleSearchParamsChange(name, value); }}
                        fields={[
                            {
                                fieldnm: '시설유형',
                                name: 'facilityTypeId',
                                type: 'select',
                                options: facilityTypes
                            },
                            {
                                fieldnm: '시설명',
                                name: 'facilityNm',
                                type: 'input',
                            },
                        ]}
                        onSearchClick={handleSearch}
                    />
                </Box>
            )}

            {/* 콘텐츠 영역 - 전체 스크롤 활용 */}
            <Box sx={{
                flex: 1,
                width: '100%',
                maxWidth: '100%',
                // 모바일에서는 전체 스크롤 허용, 부분 스크롤 제거
                ...(isMobile ? {
                    overflow: 'visible', // 스크롤 제거
                    boxSizing: 'border-box'
                } : {
                    overflow: 'auto'
                })
            }}>
                {isMobile ? (
                    // 모바일 카드 뷰 - 전체 리스트 표시
                    <Box sx={{
                        width: '100%',
                        maxWidth: '100%',
                        // 스크롤 관련 설정 제거
                        overflow: 'visible',
                        boxSizing: 'border-box'
                    }}>
                        {qrList.length > 0 ? (
                            qrList.map((item, index) => (
                                <MobileCard key={item.facilityId || index} item={item} />
                            ))
                        ) : (
                            <Paper sx={{
                                p: 3,
                                textAlign: 'center',
                                width: '100%',
                                maxWidth: '100%',
                                boxSizing: 'border-box',
                                mt: 2
                            }}>
                                <Typography color="text.secondary" sx={{ fontSize: '0.9rem' }}>
                                    검색 결과가 없습니다.
                                </Typography>
                            </Paper>
                        )}
                    </Box>
                ) : (
                    // 데스크톱 테이블 뷰
                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <DesktopTable />
                    </Paper>
                )}
            </Box>

            {/* 페이지네이션 - 하단 고정 */}
            <Box sx={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: 'center',
                mt: 2,
                gap: isMobile ? 1 : 0,
                position: 'relative',
                width: '100%',
                maxWidth: '100%',
                overflow: 'hidden',
                flexShrink: 0, // 고정 크기
                ...(isMobile && {
                    py: 2,
                    borderTop: '1px solid #e0e0e0',
                    backgroundColor: '#fafafa',
                    boxSizing: 'border-box'
                })
            }}>
                <Pagination
                    count={Math.ceil(totalElements / rowsPerPage)}
                    page={page}
                    onChange={(event, newPage) => handleChangePage(event, newPage)}
                    showFirstButton
                    showLastButton
                    size={isMobile ? "small" : "medium"}
                />

                {!isMobile && (
                    <Box sx={{ position: 'absolute', left: 0 }}>
                        <TablePagination
                            labelDisplayedRows={() => ''}
                            component="div"
                            page={page - 1}
                            count={totalElements}
                            rowsPerPageOptions={[10, 25, 50]}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleRowsPerPageChange}
                            ActionsComponent={() => null}
                            onPageChange={() => null}
                        />
                    </Box>
                )}
            </Box>

            {/* QR 모달 */}
            <Dialog
                open={qrModalOpen}
                onClose={handleCloseQrModal}
                maxWidth="sm"
                fullWidth
                fullScreen={isMobile}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <DialogTitle sx={{ fontSize: isMobile ? '1.25rem' : '1.4rem' }}>
                        {selectedQrType === 'COMPLAINT' ? '민원인 QR' : '점검자 QR'}
                    </DialogTitle>
                    <IconButton onClick={handleCloseQrModal} size="small" sx={{ margin: '10px' }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <DialogContent sx={{ px: isMobile ? 2 : 3 }}>
                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}>
                        <Box
                            sx={{
                                width: isMobile ? '200px' : '220px',
                                height: isMobile ? '200px' : '220px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '2px solid #ECECEC',
                                borderRadius: '8px',
                            }}
                        >
                            {selectedQrDetailInfo.qrImageUrl ? (
                                <img
                                    src={selectedQrDetailInfo.qrImageUrl}
                                    alt="QR 코드"
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        objectFit: 'contain',
                                    }}
                                />
                            ) : (
                                <Typography variant="body2" color="text.secondary">
                                    QR 이미지 없음
                                </Typography>
                            )}
                        </Box>

                        {selectedQrType === 'COMPLAINT' && selectedQrDetailInfo.complaintQrUrl && (
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                    marginTop: '10px',
                                    width: isMobile ? '200px' : '220px',
                                    overflowWrap: 'break-word',
                                    wordBreak: 'break-word',
                                    fontSize: isMobile ? '0.75rem' : '0.875rem',
                                    textAlign: 'center'
                                }}
                            >
                                {selectedQrDetailInfo.complaintQrUrl}
                            </Typography>
                        )}

                        <Typography
                            variant="h6"
                            sx={{
                                marginTop: '10px',
                                fontSize: isMobile ? '1.1rem' : '1.25rem',
                                textAlign: 'center'
                            }}
                        >
                            {selectedQrDetailInfo.facilityNm}
                        </Typography>
                    </Box>
                </DialogContent>

                {alert && (
                    <Alert severity="success" sx={{ mb: 2, mx: 2 }}>
                        {alert}
                    </Alert>
                )}

                {selectedQrType === 'CHECKER' && (
                    <DialogActions sx={{
                        justifyContent: 'center',
                        marginBottom: '15px',
                        gap: isMobile ? 1 : 2,
                        flexDirection: isMobile ? 'column' : 'row',
                        px: isMobile ? 2 : 3
                    }}>
                        <Button
                            variant="outlined"
                            onClick={() => handleOpenHistoryModal(selectedQrDetailInfo.facilityId)}
                            size={isMobile ? "large" : "medium"}
                            color="primary"
                            fullWidth={isMobile}
                        >
                            발행이력
                        </Button>
                        <Button
                            variant={selectedQrDetailInfo.qrImageUrl ? "outlined" : "contained"}
                            onClick={() => handleGenerateQrClick(selectedQrDetailInfo.facilityId, 'CHECKER')}
                            size={isMobile ? "large" : "medium"}
                            fullWidth={isMobile}
                        >
                            {selectedQrDetailInfo.qrImageUrl ? 'QR 재발행' : 'QR 발행'}
                        </Button>
                    </DialogActions>
                )}
            </Dialog>

            {/* 확인 다이얼로그 */}
            <Dialog
                open={confirmDialogOpen}
                onClose={handleCancelGenerate}
                fullScreen={isMobile}
                maxWidth="sm"
            >
                <DialogTitle sx={{ fontSize: isMobile ? '1.25rem' : '1.4rem' }}>
                    QR 코드 발행
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ fontSize: isMobile ? '1rem' : '1.125rem' }}>
                        QR 코드를 발행하시겠습니까?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? 1 : 0,
                    p: isMobile ? 3 : 1
                }}>
                    <Button
                        onClick={handleCancelGenerate}
                        color="primary"
                        size={isMobile ? "large" : "medium"}
                        fullWidth={isMobile}
                    >
                        취소
                    </Button>
                    <Button
                        onClick={handleConfirmGenerate}
                        color="primary"
                        autoFocus
                        size={isMobile ? "large" : "medium"}
                        fullWidth={isMobile}
                    >
                        확인
                    </Button>
                </DialogActions>
            </Dialog>

            {/* QR 발행 이력 모달 */}
            <Dialog
                open={historyModalOpen}
                onClose={handleCloseHistoryModal}
                maxWidth="md"
                fullWidth
                fullScreen={isMobile}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <DialogTitle sx={{ fontSize: isMobile ? '1.25rem' : '1.4rem' }}>
                        QR 발행 이력
                    </DialogTitle>
                    <IconButton onClick={handleCloseHistoryModal} size="small" sx={{ margin: '10px' }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <DialogContent sx={{ px: isMobile ? 1 : 3 }}>
                    {isLoadingHistory ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                            <Typography>로딩 중...</Typography>
                        </Box>
                    ) : qrHistory.length > 0 ? (
                        <TableContainer component={Paper} sx={{ maxHeight: isMobile ? '60vh' : 300 }}>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>번호</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>QR 유형</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>발행일시</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>발행자</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {qrHistory.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell align="center" sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>{index + 1}</TableCell>
                                            <TableCell align="center" sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>
                                                {item.qrType === 'COMPLAINT' ? '민원인용' : '점검자용'}
                                            </TableCell>
                                            <TableCell align="center" sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>{item.createDt}</TableCell>
                                            <TableCell align="center" sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>{item.createUser || '-'}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                            <Typography>발행 이력이 없습니다.</Typography>
                        </Box>
                    )}
                </DialogContent>

                <DialogActions sx={{ p: isMobile ? 3 : 1 }}>
                    <Button
                        onClick={handleCloseHistoryModal}
                        color="primary"
                        size={isMobile ? "large" : "medium"}
                        fullWidth={isMobile}
                    >
                        닫기
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default validationAuth(QRManagement);